import createClient from 'openapi-fetch'
import { paths as apiClientPaths } from './shared/types/api.ts'
import { paths as authClientPaths } from './shared/types/auth.ts'
import { FetchClientsContext } from './shared/context/fetch-clients/index.ts'
import { routeTree } from './routeTree.gen'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { getApiUXHeader } from './utils/headers-params.ts'
import { getInfoToken } from './services/tokenAuth.ts'

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const authClient = createClient<authClientPaths>({
  baseUrl: import.meta.env.VITE_API_URL_BASE_AUTH,
  headers:{
  }
})


const apiClient = createClient<apiClientPaths>({
  baseUrl: import.meta.env.VITE_API_URL_BASE,
  headers: getApiUXHeader("","")
})


apiClient.use({
  async onRequest({request}){
    
      const infoTokenData = await getInfoToken();
      request.headers.set('Authorization', `Bearer ${infoTokenData.token}`);

    return request;
  }
})

export const router = createRouter({ routeTree })

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {

  return (
    <QueryClientProvider client={queryClient}>
  <FetchClientsContext value={{
    apiClient,
    authClient
  }}>
    <RouterProvider basepath={import.meta.env.BASE_URL}  router={router} />
  </FetchClientsContext>
  </QueryClientProvider>)
}
